import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon, SliderInput } from '../..';

const maxHours = 2
const maxMinutes = maxHours * 60

export const mapTimeToLable = (time) => {
  const minutes = time % 60
  const hours = (time - minutes) / 60
  const hourLabel = hours ? `${hours}h` : ''
  const minuteLabel = `${minutes}m`
  return `${hourLabel} ${minuteLabel}`
}

const ContentLengthFilter = ({
  onContentLengthChange,
  toggleFilter,
  showFilter,
  filter,
  refresh
}) => {
  const {
    min,
    max
  } = filter
  const minLabel = mapTimeToLable(min)
  const maxLabel = mapTimeToLable(max)

  return (
    <div className='filter content-length-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Content Length</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id="cpd-hour-filter" in={showFilter}>
          <form noValidate>
            <div className='bottom-gap'>
              <SliderInput
                key={refresh}
                onChange={onContentLengthChange}
                min={0}
                max={maxMinutes}
                step={5}
                minLabel={minLabel}
                maxLabel={maxLabel} />
            </div>
          </form>
        </Collapse>
      </Row>
    </div>
  )
}

export default compose(
  withStateHandlers(
    {
      showFilter: false,
      filter: {
        min: 0,
        max: maxMinutes
      },
      refresh: 0
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      }),
      setFilter: () => (filter) => ({ filter }),
      resetContentLength: ({ refresh }, { contentLengthFilter }) => () => {
        const {
          min,
          max
        } = contentLengthFilter

        if (!min && !max) {
          return {
            filter: {
              min: 0,
              max: maxMinutes
            },
            refresh: refresh + 1
          }
        } else {
          return {}
        }
      }
    }
  ),
  withHandlers({
    onContentLengthChange: ({ onChange, setFilter }) => (filter) => {
      const {
        min,
        max
      } = filter
      const parsed = {
        min: min / 60,
        max: max / 60
      }
      setFilter(filter);
      onChange(parsed);
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { contentLengthFilter, resetContentLength } = this.props
      if (!fp.isEqual(contentLengthFilter)(prevStat.contentLengthFilter)) {
        resetContentLength(contentLengthFilter)
      }
    }
  })
)(ContentLengthFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/content-length-filter.js